module.exports = __webpack_public_path__ + "img/expovina-primavera_07.da1ddf40.jpg";